/**
 * Toggle a class on a specified DOM node.
 *
 * Props:
 * className(string, required): The toggled class.
 */
export default {
  name: "interactive",

  ui: {
    play: "[js-interactive-play]"
  },

  events: [
    {
      on: "click",
      target: "play",
      handle() {
        this.el.classList.add("is-playing");
        this.ui.play.classList.add("is-hidden");
      }
    }
  ]
};
